<div class="process-card ">

    <div class="card-header text-center">
        <img src="/assets/icons/avyna/logo.svg" alt="Avyna" class="brand-logo mb-3" />
        <div class="header-text">
            <h1 class="title-text">{{ 'app.auth.callback.title' | translate }}</h1>
            <p class="subtitle-text">{{ 'app.auth.callback.subtitle' | translate }}</p>
        </div>
    </div>

    <div class="content-area">

        @if (hasError()) {
        <div class="error-view animate-fade-in">
            <mat-icon class="error-icon">gpp_bad</mat-icon>
            <h2 class="error-title">{{ 'app.auth.callback.error_title' | translate }}</h2>
            <p class="error-desc">{{ errorDetail() | translate }}</p>

            <div class="actions-area mt-4">
                <button mat-flat-button class="action-btn" (click)="returnToLogin()">
                    {{ 'app.auth.callback.back_to_login' | translate }}
                </button>
            </div>
        </div>

        } @else {
        <div class="progress-view">
            <div class="message-container">
                <span class="dynamic-message animate-fade-in" [class.highlight]="progress() > 0">
                    {{ activeMessage() | translate }}
                </span>
            </div>

            <div class="progress-wrapper">
                <mat-progress-bar mode="determinate" [value]="progress()" class="custom-progress-bar">
                </mat-progress-bar>
                <div class="progress-label text-end mt-1">
                    {{ progress() | number:'1.0-0' }}%
                </div>
            </div>
        </div>
        }

    </div>

    <div class="card-footer">
        <mat-icon class="secure-icon">lock</mat-icon>
        <span>{{ 'app.auth.callback.footer' | translate }}</span>
    </div>
</div>